module.exports = __webpack_public_path__ + "img/Fashion-low.dde7826b.jpg";